export default __webpack_public_path__ + "static/media/456.81d0fbc9.gif";